import React from 'react';
import PropTypes from 'prop-types';

import { WHITE } from '@constant/colors';

const Appstore = ({ width, color }) => (
  <svg width={width} height={width} viewBox="424 135 26 23">
    <path
      fill={color}
      fillRule="evenodd"
      d="M449.5122 149.4132h-3.2455l-1.8206-3.244h5.0662v3.244zm-2.2302 7.8243s-.2298-.9433-.9887-1.6343c-.4154-.3783-1.2934-.7002-1.6333-1.2217-.9407-1.4436-.1566-2.0972-.0144-2.1874.004-.0064.005-.012.0265-.025.4014-.2388.895-.5358 1.3136-.785.0306-.018.117-.068.0883-.0523.3778-.2057 1.5604.198 1.8767 2.3398.2542 1.72-.6687 3.566-.6687 3.566zm-5.017-7.7724l2.4986-1.465 1.4648 2.4985-2.4982 1.465-1.465-2.4984zm-6.6617-11.756c-.186-.5175-.1175-1.0895.3274-1.3238l.775-.4203c.6138-.2346 1.0652.1477 1.2272.4237l6.5375 11.1117-2.4985 1.465-6.3687-11.2564zm-2.7358 11.4725l1.6085-3.0122h5.2336l1.631 3.0122h-8.473zm-5.6025 2.573l5.6736-9.7678 2.5046 1.4547-5.6736 9.7676-2.5046-1.4546zm-1.5607 5.4285l1.27-4.9277 2.5045 1.4547-3.7745 3.473zm-1.2165-11.0137h5.344l-1.7122 3.0122h-3.6318v-3.0122zm9.597-6.129c.1607-.2766.6602-.642 1.2446-.3185l.8872.4928c.349.215.624.696.391 1.2804l-.8736 1.4457c-.2146-.125-.3576-.208-.4535-.2635.004.002.002.001-.0063-.0037-.0002-.0002-.0007-.0002-.001-.0005l.0008.0003-.0292-.017c-.001-.0006-.0023.0186-.0035.018-.0002 0-.0007.0194-.001.0194h-.0003c-.002 0-.0937-.0223-.0937-.024v-.01c0-.0135-.0004-.0304-.0157-.0395.003.002.0276.001.0308.0028l-.0317-.026c.001.0007.007.0005.0085.0012-.004-.002-.0055-.005-.0085-.0067-.0183-.0107-.021-.0132-.0035-.003l-1.3965-.8117c-.011-.0065-.0167-.0097-.0232-.0137-.007-.0038-.014-.008-.024-.014.004.0025.0127.0074.018.0104l-.036-.0208-.435-.2528.8554-1.4454z"
    />
  </svg>
);

Appstore.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
};

Appstore.defaultProps = {
  color: WHITE,
  width: 19,
};

export default Appstore;
